import React from 'react';
import { useSelector } from 'react-redux';
import { Typography, Layout, Row, Col, Flex, Table } from 'antd';

import { getAppSettings } from '../../selectors';

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

const developerStyle = {
  innerLayout: {
    width: '100%',
    padding: '0 1rem 2rem',
    height: 'max-content',
  },
  header: {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '2.4rem 0',
    background: 'none',
    height: 'auto',
  },
  headerTitle: {
    marginBottom: 0,
    marginTop: 0,
    fontWeight: 400,
  },
  headerParagraph: {
    fontWeight: 400,
    whiteSpace: 'wrap',
  },
  content: {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '2rem',
    background: '#ffffff',
    borderRadius: '4px 4px 0 0',
    border: '1px solid rgb(229, 231, 233)',
  },
  contentTable: {
    width: '100%',
  },
  button: {
    width: '20rem',
  },
};

const tableColumns = [
  {
    title: 'Key',
    key: 'keyName',
    width: '30%',
    render: ({ keyName }: { keyName: string }) => (
      <Paragraph>{keyName}</Paragraph>
    ),
  },
  {
    title: 'Value',
    key: 'value',
    width: '70%',
    render: ({ keyName, value }: { keyName: string; value: string }) =>
      ['whiteLabelConfiguration', 'featureToggles'].includes(keyName) ? (
        <Paragraph>
          <pre>{value}</pre>
        </Paragraph>
      ) : (
        <Paragraph
          code
          copyable={[
            'organizationId',
            'merchantAccountId',
            'merchantId',
            'packageCode',
          ].includes(keyName)}
        >
          {value || 'undefined'}
        </Paragraph>
      ),
  },
];

export function Developer() {
  const settings = useSelector(getAppSettings);
  const dataSourceSettings = Object.entries(settings).map(([key, value]) => ({
    keyName: key,
    value: typeof value === 'string' ? value : JSON.stringify(value, null, 2),
  }));

  return (
    <Layout style={developerStyle.innerLayout}>
      <Header style={developerStyle.header}>
        <Title level={3} style={developerStyle.headerTitle}>
          Developer Tools
        </Title>
        <Paragraph type="secondary" style={developerStyle.headerParagraph}>
          This page is intended for internal use only and is not meant for
          merchants. It provides developer-specific information useful for
          debugging or inspecting the current environment context.
        </Paragraph>
      </Header>
      <Content style={developerStyle.content}>
        <Row justify="space-between" align="middle" gutter={[16, 16]}>
          <Col span={24}>
            <Title level={4} style={{ marginTop: 0 }}>
              Settings Properties Passed by App Shell to Microfrontend
              Applications
            </Title>
            <Paragraph type="secondary" style={developerStyle.headerParagraph}>
              These are the setting property values for this merchant that the
              App Shell passes to microfrontend applications to ensure
              consistent behavior, communication, and seamless integration
              across the system.
            </Paragraph>
          </Col>
          <Col span={24}>
            <Flex align="center" justify="center">
              <Table
                bordered
                rowKey="keyName"
                size="small"
                pagination={false}
                columns={tableColumns}
                dataSource={dataSourceSettings}
                style={developerStyle.contentTable}
              />
            </Flex>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
}
